module.exports = __webpack_public_path__ + "4d3cbf48852cfb11359a3e7d816d375f.pdf";